export default {
  rawSectorAutomativeData: null,
  categorySectorData: [],
  BankingCard: false,
  CreditComboBoxes: false,
  energyBoxesFlag: false,
  responseMechanism: null,
  responseMechanismAPI: null,
  sectorIdComm: [],
  sectorAllIds: [],
  SectorCommData: [],
  rangeSlider: [],
  mortgageSelectedFlag: null,
  productName: false,
  CategorySectorData: [],
  subCategorySectorData: [],
  subSubCategorySectorData: [],
  isAutomativeOptionOn: false,
  isCreditSectorOptionOn: false,
  isTravelOptionOn: false,
  isBankingSectorOptionOn: false,
  isEnergyOptionOn: false,
  isHRPayrollOptionOn: false,
  isInsuranceOptionOn: false,
  isInvestmentsOptionOn: false,
  isMortgageOptionOn: false,
  isPharmaceuticalOptionOn: false,
  isEstateOptionOn: false,
  isRetailOptionOn: false,
  isShippingOptionOn: false,
  isTelecomOptionOn: false,
  insuranceBoxFlag: false,
  investmentBoxFlag: false,
  retailTravelFlag: false,
  sectorIdRidersData: [],
  sectorFaceAmtData: [],
  sectorIssueTypeData: [],
  categoryFieldsCleaning: false,
  checkboxPayload: {},
  checkboxPayloadCopy: {},
  targetIds: [],
  campaign_language: 0,
  sectorIdOfferOriginData: [],

  delivery_method_id: [],
  delivery_type_id: [],
  package_type_id: [],
  presorted_id: [],
  postage_id: [],
  energySelPayload: {},
  SectorEDCEnergyData: [],
  siDropDownPayload: {},
  subCategorySelected: [],
  subSubCategorySelected: [],
  allSectorsChildren: [],
  categoryPayload: {
    categories: "field:sector_id",
    cat_: [],
    cat_sub: [],
    cat_ssub: [],
  },
  loanAmount: {
    min: 0,
    max: 2000000,
    changeHappen: false,
  },
  affinityCategory: {},
  dropDownData: {
    energyRateType: [],
    dma: [],
    cscanEdc: [],
    incomeProducing: [],
    scoreHousehold: [],
    etermLength: [],
  },
  defaultDropDownData: {},
  termLenghtData: [],
  setBankCreditAction: false,
  allSectorsLocal: [],
  allSubSectorsLocal: [],
  allSubSubSectorsLocal: [],
  selectFlagStore: false,
  orignalCommuncationCopied: [],
  // Mutation commication type temp ones;
  sectorIDs: [],
  audienceIDs: [],
  selectedData: {},
  iSLastSearchFlag: false,
  categoriesParents: { cat: [], subcat: [], subsubcat: [] },
};
